import axios from "axios";
import { BASE_URL } from "../../variables";

export const UpdateMeeting = async ({ formDataWithId}) => {
     
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    //   Authorization: `Bearer ${globalAccessToken}`,
    };
  
    const options = {
      url: `${BASE_URL}/services/apexrest/Update_DRM_Plan/`,
      method: "PUT",
      headers: headers,
      data: {
        "DRM": [ formDataWithId ] 
      },
    };
    try { 
      const response = await axios(options);
      if (response?.data.success === true) {
        return {
          success: true,
          data: response?.data?.message,
        };
      } else {
        return {
          success: true,
          data: response?.data?.message,
        };
      }
    } catch (err) {
      return {
        success: false,
        msg: "Somthing Went Wrong..!!",err,
      };
    }
  };